import { render } from "./JJ.vue?vue&type=template&id=ce7f2612"
import script from "./JJ.vue?vue&type=script&lang=js"
export * from "./JJ.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__